$(document).on('turbolinks:load', function() {
  // トップページ以外では実行しない
  if (!window.Janreco.currentPath().match(/^\/$/)) {
    return;
  }

  const $toggleBtn = $('#play-type-toggle-switch');
  const $scoreTitle = $('#score-title');
  const $result4 = $('#result-4');
  const $result3 = $('#result-3');

  if ($toggleBtn.length === 0) {
    return;
  }

  // URLパラメータから初期状態を取得
  let params = new URLSearchParams(window.location.search);
  let playType = params.get('play_type');
  // URLパラメータがない場合はサーバーから渡されたデフォルト値を使用
  let currentType = playType ? parseInt(playType) : ($toggleBtn.data('default-type') || 4);

  // カレンダーと合計を切替
  function togglePointCalendar(type) {
    if (type === 4) {
      $('#calendar-4').show();
      $('#calendar-3').hide();
      $('#point-calendar-summary-4').show();
      $('#point-calendar-summary-3').hide();
    } else {
      $('#calendar-3').show();
      $('#calendar-4').hide();
      $('#point-calendar-summary-4').hide();
      $('#point-calendar-summary-3').show();
    }
    // 合計値の差し替え
    const $totalWrap = $('.top-contents-lower .total-point');
    const $valueEl = $totalWrap.find('.value');
    if ($totalWrap.length && $valueEl.length) {
      const total4 = parseFloat($totalWrap.data('total4')) || 0;
      const total3 = parseFloat($totalWrap.data('total3')) || 0;
      const v = (type === 4 ? total4 : total3);
      const sign = v > 0 ? '+' : '';
      $valueEl.removeClass('plus minus');
      if (v > 0) { $valueEl.addClass('plus'); }
      if (v < 0) { $valueEl.addClass('minus'); }
      $valueEl.text(sign + v.toFixed(1));
    }
    // 対局数バッジの差し替え（unit はdata属性経由でロケール対応）
    const $countEl = $('#score-calendar-count');
    if ($countEl.length) {
      const c = (type === 4 ? $countEl.data('count4') : $countEl.data('count3')) || 0;
      const unit = $countEl.data('unit') || '';
      $countEl.text('（' + c + unit + '）');
    }
  }

  // 関数定義
  function updateSwitchState(type) {
    const $fourOption = $toggleBtn.find('[data-type="4"]');
    const $threeOption = $toggleBtn.find('[data-type="3"]');

    // 全ての状態をリセット
    $fourOption.removeClass('active');
    $threeOption.removeClass('active');
    $toggleBtn.removeClass('three-active');

    if (type === 4) {
      $fourOption.addClass('active');
      // タイトルはdata属性経由でロケール対応
      $scoreTitle.text($scoreTitle.data('title4') || '');
    } else {
      $threeOption.addClass('active');
      $toggleBtn.addClass('three-active');
      $scoreTitle.text($scoreTitle.data('title3') || '');
    }
  }

  function updateResults(type) {
    if (type === 4) {
      $result4.show();
      $result3.hide();
      if (typeof window.redrawDoughnutChart4 === 'function') { window.redrawDoughnutChart4(); }
      if (typeof window.redrawRankLineChart4 === 'function') { window.redrawRankLineChart4(); }
    } else {
      $result3.show();
      $result4.hide();
      if (typeof window.redrawDoughnutChart3 === 'function') { window.redrawDoughnutChart3(); }
      if (typeof window.redrawRankLineChart3 === 'function') { window.redrawRankLineChart3(); }
    }
    // 成績カレンダー同期
    togglePointCalendar(type);
  }

  // スイッチ風ボタンの設定
  const $switchOptions = $toggleBtn.find('.switch-option');

  $switchOptions.each(function(index, element) {
    const $option = $(element);
    const optionType = $option.data('type');

    $option.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const newType = parseInt(optionType);

      if (newType !== currentType) {
        currentType = newType;
        updateSwitchState(currentType);
        updateResults(currentType);

        // URLを更新（ページリロードなし）
        const newUrl = new URL(window.location);
        newUrl.searchParams.set('play_type', currentType);
        window.history.pushState({}, '', newUrl);
      }
    });
  });

  // 初期状態を設定
  updateSwitchState(currentType);
  updateResults(currentType);
});
